import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Stack from "react-bootstrap/Stack";
import { Container, Tabs, Tab, Col } from "react-bootstrap";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/Store";
import AddSchedule from "../manageScedule/components/AddScedule";
import BasicDetails from "../basicDetails/components/BasicDetails";
import ViewSchedule from "../manageScedule/components/ViewScedule";
import { FeatureAccess } from "../../../services/AuthService";
import { FetchQMEDoctorScheduleList } from "../../../services/DoctorScheduleAPI";
import ScheduleList from "./components/ScheduleList";
import { fetchValideQMEDoctorScheduling } from "../../../services/CaseInformationApi";
import SearchableSingleSelectDropdown from "../../../common/SearchableDropdown";
import { fetchQMEDoctorContacts } from "../../../services/ScheduleAppointmentApi";
import { FetchStakeholderContactByUserId } from "../../../services/DoctorScheduleAPI";
interface AddNewProps {
  userData: any;
  action: string;
  tabState: string;
  selctedyear: number;
}

const DoctorSchedule: React.FC<AddNewProps> = ({
  userData,
  action,
  tabState,
  selctedyear,
}) => {
  const loggedInUserid = useSelector((state: RootState) => state.auth.userid);
  const [activeTab, setActiveTab] = useState<string>("");
  const [subTab, setSubTab] = useState<string>(tabState || "Add Schedule");
  const [subTabView, setSubTabView] = useState<string>(
    tabState || "View Schedule"
  );
  const userRole = localStorage.getItem("userrole") || "";
  const roles = userRole ? userRole.split(",").map((r) => r.trim()) : [];
  const allowedAccessRoles = [
    "Case Coordinator",
    "Practice Manager (PMC Staff)",
    "Medical Assistant",
  ];
  const isAccessToTabs = roles.some((role) =>
    allowedAccessRoles.includes(role)
  );

  const [enabledTabs, setEnabledTabs] = useState<{ [key: string]: boolean }>({
    "Basic Details": false,
    "Manage Schedule": false,
  });
  const { caseInfoId, client_stakeholderId } = useSelector(
    (state: RootState) => state.caseHeader
  );

  useEffect(() => {
    const fetchFeatureAccess = async () => {
      try {
        const token = localStorage.getItem("token");
        const featureAccess = await FeatureAccess(String(token));

        if (Array.isArray(featureAccess.result)) {
          const features = featureAccess.result.map(
            (f: { featureId: number; featureDesc: string }) => f.featureDesc
          );

          setEnabledTabs({
            "Basic Details": features.includes("QME Profile \\ Basic Details"),
            "Manage Schedule": features.includes(
              "QME Profile \\ Manage Schedule"
            ),
          });

          // Set default active tab if available
          if (features.includes("QME Profile \\ Basic Details")) {
            setActiveTab("Basic Details");
          } else if (features.includes("QME Profile \\ Manage Schedule")) {
            setActiveTab("Manage Schedule");
          }
        }
      } catch (error) {
        console.error("Error fetching feature access:", error);
      }
    };

    fetchFeatureAccess();
  }, []);

  const [doctorId, setDoctorId] = useState<any>(1);
  const [year, setYear] = useState<number>(
    selctedyear || new Date().getFullYear()
  );

  // const [month, setMonth] = useState<string>("Mar");
  const [month, setMonth] = useState<string>(
    new Date().toLocaleString("default", { month: "long" })
  );
  const [hospital, setHospital] = useState<string>("");

  const [doctorSchedule, setDoctorSchedule] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [isDoctorSchedule, setIsDoctorSchedule] = useState<boolean>(false);
  const [QMEDoctor, setQMEDoctor] = useState<string | null | number>(null);
  const allowedRoles = [
    "Case Coordinator",
    "Practice Manager (PMC Staff)",
    "Record Reviewer",
    "Editor",
    "Transcriber",
    "Historian",
    "Billing Specialist",
    "App Admin",
    "Medical Assistant",
  ];
  const isQMEDoctor = roles.some((role) => allowedRoles.includes(role))
    ? true
    : false;

  const [QMEDoctorOptions, setQMEDoctorOptions] = useState<
    {
      value: string;
      label: string;
      specialization: string;
      experienceInYears: string;
    }[]
  >([]);

  const fetchDoctorSchedule = async () => {
    try {
      const idToPass = roles.some((role) => allowedRoles.includes(role))
        ? QMEDoctor
        : Number(loggedInUserid);

      const response = await fetchValideQMEDoctorScheduling(Number(idToPass));

      setIsDoctorSchedule(response?.isAllowScheduling == 0 ? true : false);
      setSubTab(response?.isAllowScheduling == 0 ? "View Schedule" : subTab);
    } catch (error) {
      console.error("Error while fetching qme doctor schedule data:", error);
    }
  };
  type Option = { value: string; label: string };

  useEffect(() => {
    const fetchData = async () => {
      if (isQMEDoctor) {
        if (QMEDoctorOptions?.length) {
          const stillExists = QMEDoctorOptions.some(
            (o: { value: string | number }) => o.value === QMEDoctor
          );
          if (!stillExists) {
            setQMEDoctor(QMEDoctorOptions[0].value);
          }
        } else {
          setQMEDoctor(null);
        }
      } else {
        try {
          const response = await FetchStakeholderContactByUserId(
            loggedInUserid
          );
          if (response?.isSuccess && response.result?.stakeholderContactId) {
            setQMEDoctor(response.result.stakeholderContactId);
          } else {
            console.warn("⚠️ No Stakeholder Contact ID found.");
          }
        } catch (error) {
          console.error("❌ Error fetching stakeholder contact:", error);
        }
      }
    };

    fetchData();
  }, [QMEDoctorOptions, isQMEDoctor, QMEDoctor, loggedInUserid]);

  useEffect(() => {
    if (QMEDoctor) {
      fetchDoctorSchedule();
    }
  }, [QMEDoctor]);

  const fetcQMEDoctors = async () => {
    try {
      const response = await fetchQMEDoctorContacts(Number(loggedInUserid));
      setQMEDoctorOptions(response);
    } catch (error) {
      console.error("Error while fetching qme doctor schedule data:", error);
    }
  };
  useEffect(() => {
    fetcQMEDoctors();
  }, []);

  useEffect(() => {
    const fetchSchedule = async () => {
      try {
        const response = await FetchQMEDoctorScheduleList(
          doctorId,
          year,
          month,
          hospital
        );
        setDoctorSchedule(response.result);
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchSchedule();
    fetchDoctorSchedule();
  }, [doctorId, year, month, hospital]);

  const [selectedRowData, setSelectedRowData] = useState(null);
  const isAccess = isDoctorSchedule && !isAccessToTabs;

  const handleTabChange = (tab: string) => {
    setSubTab(tab);
    setSelectedRowData(null);
  };

  const handleRowAction = (row: any) => {
    setSubTab("Add Schedule");
    setSelectedRowData(row);
  };

  useEffect(() => {
    if (subTab != "Add Schedule" || activeTab === "Basic Details") {
      setSelectedRowData(null);
    }
  }, [subTab, activeTab]);

  return (
    <div>
      {/* Header Section */}
      <div className="breadcrumbg pb-0 " style={{ paddingTop: "10px" }}>
        <Container fluid className="px-5">
          <Stack direction="horizontal" gap={2}>
            <Col className="pt-0 flex-column d-flex align-items-start fade-in-left">
              <h4>DOCTOR SCHEDULE</h4>

              {/* Main Tabs */}
              <Tabs
                activeKey={activeTab}
                onSelect={(tab) => tab && setActiveTab(tab)}
                className="mb-0 Tab_borderBottom fade-in-left"
              >
                {enabledTabs["Basic Details"] && (
                  <Tab eventKey="Basic Details" title="Basic Details" />
                )}
                {enabledTabs["Manage Schedule"] && (
                  <Tab eventKey="Manage Schedule" title="Manage Schedule" />
                )}
              </Tabs>
            </Col>

            {roles.some((role: string) =>
              [
                "Case Coordinator",
                "Practice Manager (PMC Staff)",
                "Record Reviewer",
                "Editor",
                "Transcriber",
                "Historian",
                "Billing Specialist",
                "App Admin",
                "Medical Assistant",
              ].includes(role)
            ) && (
              <Col
                sm={3}
                className="selection_dropdown mt-0 bg-white qme-doctor"
              >
                <SearchableSingleSelectDropdown
                  label="QME Doctor"
                  name="QMEDoctor"
                  options={QMEDoctorOptions}
                  value={QMEDoctor ?? ""}
                  onChange={(e, name, value) => {
                    const next =
                      value && typeof value === "object"
                        ? (value as Option).value
                        : (value as string | null);
                    setQMEDoctor(next);
                  }}
                />
              </Col>
            )}
          </Stack>
        </Container>
      </div>

      {/* Content Section */}
      <div className="main_wrapper_section pills_wrapper">
        <Container fluid className="px-5 mt-1">
          {activeTab === "Basic Details" && (
            <Col md={12}>
              <BasicDetails QMEDoctor={QMEDoctor} />
            </Col>
          )}

          {activeTab === "Manage Schedule" &&
            enabledTabs["Manage Schedule"] &&
            (isAccess ? (
              <Tabs
                activeKey={subTab}
                onSelect={(tab) => tab && setSubTab(tab)}
                className="mb-3 mt-3 fade-in-left"
              >
                <Tab eventKey="View Schedule" title="View Schedule">
                  <ViewSchedule
                    doctorId={doctorId}
                    year={year}
                    month={month}
                    hospital={hospital}
                    onRowSelect={handleRowAction}
                    subTab={subTab}
                    isDoctorSchedule={isDoctorSchedule}
                    QMEDoctor={QMEDoctor}
                  />
                </Tab>
              </Tabs>
            ) : (
              <Tabs
                defaultActiveKey={
                  tabState === "View Schedule"
                    ? "View Schedule"
                    : "Add Schedule"
                }
                activeKey={subTab}
                onSelect={(tab) => tab && setSubTab(tab)}
                className="mb-3 mt-3 fade-in-left"
              >
                <Tab eventKey="Add Schedule" title="Add Schedule">
                  <AddSchedule
                    selectedRowData={selectedRowData}
                    onTabChange={() => handleTabChange("Schedule List")}
                    subTab={subTab}
                    QMEDoctor={QMEDoctor}
                  />
                </Tab>
                <Tab eventKey="Schedule List" title="Schedule List">
                  <ScheduleList
                    qmeDoctorContactId={doctorId}
                    year={null}
                    month={null}
                    hospital={null}
                    onRowSelect={handleRowAction}
                    subTab={subTab}
                    QMEDoctor={QMEDoctor}
                  />
                </Tab>
                <Tab eventKey="View Schedule" title="View Schedule">
                  <ViewSchedule
                    doctorId={doctorId}
                    year={year}
                    month={month}
                    hospital={hospital}
                    onRowSelect={handleRowAction}
                    subTab={subTab}
                    isDoctorSchedule={isDoctorSchedule}
                    QMEDoctor={QMEDoctor}
                  />
                </Tab>
              </Tabs>
            ))}
        </Container>
      </div>
    </div>
  );
};

export default DoctorSchedule;
